import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Signature on-load moment: reveals brand mark then lifts curtain.
export default function Preloader() {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setGone(true), 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[1000] bg-[#1C1C1A] text-[#F7F5F2] flex items-center justify-center"
        >
          <motion.div
            initial={{ opacity: 0, letterSpacing: "0.05em" }}
            animate={{ opacity: 1, letterSpacing: "0.32em" }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-3xl md:text-5xl uppercase"
          >
            Diamant
          </motion.div>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
            className="absolute bottom-8 right-8 text-[10px] tracking-[0.32em] uppercase text-[#E5D5C1]/70"
          >
            You Dream — We Create
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
